var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body chat"},[_c('div',{staticClass:"yours messages"},[_c('div',{staticClass:"message last",domProps:{"innerHTML":_vm._s(_vm.message.replace(/\n/g, '<br/>'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }